import React from 'react';
import { FormattedNumber } from 'react-intl';
import { get as _get } from 'lodash-es';
import { defaultCurrency, defaultCurrencySub } from '../utils/Constants';

export const ProductPriceString = ({
  price,
  compareAtPrice,
  currency,
  middleString,
  endingString,
}) => {
  const priceTag = (
    <span className="xrs-product__price">
      {price < compareAtPrice && compareAtPrice != 0 ? (
        <>
          <del>
            <FormattedNumber
              value={compareAtPrice}
              style="currency"
              currency={defaultCurrency ? defaultCurrency : currency}
              minimumFractionDigits={2}
              maximumFractionDigits={2}
            />
            {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
          </del>
          {middleString && (
            <span style={{ marginRight: '3px' }}>
              {middleString}
              {`  `}
            </span>
          )}
        </>
      ) : null}
      <FormattedNumber
        value={price}
        style="currency"
        currency={defaultCurrency ? defaultCurrency : currency}
        minimumFractionDigits={2}
        maximumFractionDigits={2}
      />
      {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
      {endingString && (
        <span style={{ color: '#3f7e23', marginLeft: '5px' }}>
          Save&nbsp;
          <FormattedNumber
            value={endingString}
            style="currency"
            currency={defaultCurrency ? defaultCurrency : currency}
            minimumFractionDigits={2}
            maximumFractionDigits={2}
          />
          {defaultCurrencySub ? ` ` + defaultCurrencySub : ''}
        </span>
      )}
    </span>
  );

  return priceTag;
};
